import { render } from "./ArenaFactBox.vue?vue&type=template&id=6d2b2ee8"
import script from "./ArenaFactBox.vue?vue&type=script&lang=js"
export * from "./ArenaFactBox.vue?vue&type=script&lang=js"

import "./ArenaFactBox.vue?vue&type=style&index=0&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6d2b2ee8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d2b2ee8', script)) {
    api.reload('6d2b2ee8', script)
  }
  
  module.hot.accept("./ArenaFactBox.vue?vue&type=template&id=6d2b2ee8", () => {
    api.rerender('6d2b2ee8', render)
  })

}

script.__file = "src/components/ArenaFactBox.vue"

export default script